import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { useQuestionEditorStore } from "../../QuestionEditor.store";

import { Checkbox, FormControlLabel } from "@components/base";

const IsRequired: FC = () => {
  const { isRequired, setIsRequired } = useQuestionEditorStore();
  const { t } = useTranslation();

  const handleChange = (): void => {
    setIsRequired(!isRequired);
  };

  return (
    <FormControlLabel
      control={<Checkbox checked={isRequired} onChange={handleChange} />}
      label={t("validation.question")}
    />
  );
};

export default IsRequired;
